module.exports = __webpack_public_path__ + "static/media/dollar.8298d8e2.svg";